// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseDataGrid_container__2GOIF"};